import styled from 'styled-components'

export const TransparentButton = styled.button`
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
`
